import React, { useState } from 'react';
import { Image } from 'antd';
import type { SupportAttachment } from '../../../services/supportTicketsService';

function isImageAttachment(a: SupportAttachment): boolean {
  const ft = (a.fileType ?? '').toUpperCase();
  const mt = (a.mimeType ?? '').toLowerCase();
  return ft === 'IMAGE' || mt.startsWith('image/');
}

function ImageWithFallback({
  thumbUrl,
  url,
  alt,
}: {
  thumbUrl?: string | null;
  url: string;
  alt: string;
}) {
  const src = thumbUrl || url;
  const [currentSrc, setCurrentSrc] = useState(src);
  return (
    <Image
      width={120}
      height={120}
      src={currentSrc}
      alt={alt}
      style={{ objectFit: 'cover', borderRadius: 8 }}
      referrerPolicy="no-referrer"
      onError={() => {
        if (currentSrc !== url) setCurrentSrc(url);
      }}
    />
  );
}

interface AttachmentViewerProps {
  attachments: SupportAttachment[];
}

export const AttachmentViewer: React.FC<AttachmentViewerProps> = ({
  attachments,
}) => {
  if (!attachments?.length) return null;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
      {attachments.map(a => (
        <div key={a.id}>
          {isImageAttachment(a) ? (
            <ImageWithFallback
              thumbUrl={a.thumbUrl}
              url={a.url}
              alt={a.fileName || 'attachment'}
            />
          ) : (
            <a
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 12px',
                background: '#f5f5f5',
                borderRadius: 8,
                color: '#1890ff',
              }}
            >
              {a.fileName || 'File'}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};
